export const approvalStatus = Object.freeze({
	None: 0,
	Pending: 1,
	Approved: 2,
});
